module.exports = __webpack_public_path__ + "static/media/alert-icon-dark.76213640.svg";